import { Input, Table, TableColumnsType } from "antd";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { balanceBadge, sortIcon } from "components/Table";
import Action from "./components/Action";
import useDriverWallet from "hooks/driverWallets/useDriverWallet";
import { IDriverWallet } from "models/driverWallet";
import { IDriver } from "models/driver";
import { WalletAlertContextProvider } from "./components/AlertContext";
import { SearchOutlined } from "@ant-design/icons";

export default function DriverWallet() {
  const {
    data: { data, loading, page, per_page, total, search },
    handlePageChange,
    handleSearch,
  } = useDriverWallet();

  return (
    <WalletAlertContextProvider>
      <div className="w-full">
        <div className="w-full px-6 flex flex-wrap-reverse">
          <Input
            className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
            prefix={<SearchOutlined className="mr-2" />}
            placeholder="Search..."
            onChange={handleSearch}
            value={search}
          />
        </div>
        <div className="w-full mt-8 px-4">
          <Table
            loading={loading}
            columns={columns(page, per_page)}
            dataSource={data}
            onChange={handlePageChange}
            pagination={{
              total,
              pageSize: per_page,
              current: page,
              nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <NextIcon />
                </span>
              ),
              prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <PreviousIcon />
                </span>
              ),
            }}
          />
        </div>
      </div>
    </WalletAlertContextProvider>
  );
}

const columns = (
  page: number,
  perPage: number
): TableColumnsType<IDriverWallet> => [
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        No
        {/* <div style={{ display: "flex", flexDirection: "column" }}>
          <Button
            type="text"
            size="small"
            icon={<CaretUpOutlined />}
            className="h-[12px]"
          />
          <Button
            type="text"
            size="small"
            icon={<CaretDownOutlined />}
            className="h-[12px]"
          />
        </div> */}
      </div>
    ),
    render: (_, __, index) => {
      // Calculate base number based on pagination
      let number = index + 1 + (page - 1) * perPage;

      // Apply sorting if needed
      // if (sortDirection === "desc") {
      //   number = dataSource.length - index + (page - 1) * perPage;
      // }

      return <p className="text-base font-medium">{number}</p>;
    },
  },
  {
    title: "Driver",
    dataIndex: "driver",
    sorter: (a, b) =>
      `${a.driver.first_name} ${a.driver.middle_name} ${a.driver.last_name}`.localeCompare(
        `${b.driver.first_name} ${b.driver.middle_name} ${b.driver.last_name}`
      ),
    sortIcon,
    render: (value: IDriver) => (
      <p>
        {value.first_name} {value.middle_name} {value.last_name}
      </p>
    ),
  },
  {
    title: "Phone",
    dataIndex: "driver",
    sorter: (a, b) => a.driver.phone.localeCompare(b.driver.phone),
    sortIcon,
    render: (value: IDriver) => <p>{value.phone}</p>,
  },
  {
    title: "Bank",
    dataIndex: "bank",
    sortIcon,
    sorter: (a, b) => a.bank.localeCompare(b.bank),
  },
  {
    title: "Account",
    dataIndex: "account",
    sortIcon,
    sorter: (a, b) => a.account.localeCompare(b.account),
  },
  {
    title: "Balance",
    dataIndex: "balance",
    sortIcon,
    render: balanceBadge,
    sorter: (a, b) => a.balance - b.balance,
  },
  {
    title: "Action",
    render: (value: IDriverWallet) => <Action wallet={value} />,
  },
];
